import type { FC } from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import navData from '../data/navigation/navs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { Dropdown, Flex } from 'antd';

interface NavMenuProps {
  className?: string;
}

const NavMenu: FC<NavMenuProps> = ({ className = undefined }) => {
  const isAuth = useSelector((state: RootState) => state.isAuth.isAuth);
  const { t } = useTranslation();
  const isDetailsActive = useMatch('/details/*');

  const navBlock = navData?.map((item) => {
    const { id, link, Icon, name, className, children } = item;

    if (link === '/profile' && !isAuth) return null;

    const items = item?.children?.map((unit) => {
      return {
        key: unit?.id,
        label: (
          <NavLink to={unit?.link} className={({ isActive }) => (isActive ? 'activeNav' : 'undefined')}>
            <span>{t(unit?.name)}</span>
          </NavLink>
        )
      };
    });
    return (
      <li key={id} className={className}>
        {children ? (
          <Dropdown
            menu={{ items }}
            className={`${isDetailsActive ? 'activeNav' : 'undefined'}`}
            popupRender={(menu) => <Flex className="navigation__dropdown">{menu}</Flex>}
          >
            <Flex>
              <Icon /> <span>{t(name)}</span>
            </Flex>
          </Dropdown>
        ) : (
          <NavLink to={link} className={({ isActive }) => (isActive ? 'activeNav' : 'undefined')}>
            {<Icon />}
            <span>{t(name)}</span>
          </NavLink>
        )}
      </li>
    );
  });

  return (
    <nav className={`navigation ${className}`}>
      <ul>{navBlock}</ul>
    </nav>
  );
};

export default NavMenu;
